import { env } from "../env";

const PLACEHOLDER_ORIGIN = "http://redirect-to.placeholder";

// matches //, /\, \/, and \\ prefixes — the URL parser treats \ like / in http(s) URLs
const PROTOCOL_RELATIVE_PREFIX = /^[/\\]{2}/;

/**
 * Restricts `redirectTo` targets to same-origin paths or hosts on the app
 * domain, so untrusted query params can't redirect parkers off-site.
 */
export const sanitizeRedirectTo = (value: string | null | undefined): string | undefined => {
	if (!value || PROTOCOL_RELATIVE_PREFIX.test(value)) {
		return undefined;
	}
	let url: URL;
	try {
		url = new URL(value, PLACEHOLDER_ORIGIN);
	} catch {
		return undefined;
	}
	if (url.origin === PLACEHOLDER_ORIGIN) {
		if (!value.startsWith("/")) {
			return undefined;
		}
		return `${url.pathname}${url.search}${url.hash}`;
	}
	if (url.protocol !== "http:" && url.protocol !== "https:") {
		return undefined;
	}
	if (url.hostname === env.NEXT_PUBLIC_APP_DOMAIN || url.hostname.endsWith(`.${env.NEXT_PUBLIC_APP_DOMAIN}`)) {
		return url.toString();
	}
	return undefined;
};
